import { IRequirementModel } from '../../../../../../../service/requirement/entity/IRequirementModel';
import { DataGridDetailUI } from '../../../../../../design/dataTable/parts/detail/DataGridDetailUI';
import { IDataGridDetailUI } from '../../../../../../design/dataTable/parts/detail/IDataGridDetailUI';
import RequirementEntityDetailComponents from './RequirementEntityDetailComponents';

export class RequirementEntityDetailUI
  extends DataGridDetailUI<IRequirementModel>
  implements IDataGridDetailUI<IRequirementModel>
{
  constructor() {
    super();
    this.getDetailPanelContent.setValue(RequirementEntityDetailComponents);
  }
}
